import type { FC } from "react";
import { Breadcrumb, BreadcrumbItem } from "flowbite-react";
import { HiHome } from "react-icons/hi";
import NavbarSidebarLayout from "../../layouts/navbar-sidebar";
import MapboxSearchBox from "./MapboxSearchBox";

const TestMapboxPage: FC = () => {
  return (
    <NavbarSidebarLayout pageTitle="Mapbox Test">
      <div className="p-4">
        <div className="block items-center justify-between border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex lg:mt-1.5">
          <div className="mb-1 w-full">
            <div className="mb-4">
              <Breadcrumb className="mb-4">
                <BreadcrumbItem href="#">
                  <div className="flex items-center gap-x-3">
                    <HiHome className="text-xl" />
                    <span className="dark:text-white">Startseite</span>
                  </div>
                </BreadcrumbItem>
                <BreadcrumbItem>Mapbox Test</BreadcrumbItem>
              </Breadcrumb>
              <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">
                Mapbox Geocoding Test
              </h1>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <MapboxSearchBox />
        </div>
      </div>
    </NavbarSidebarLayout>
  );
};

export default TestMapboxPage;
